export const WORKFLOW_WAKE_SIGNAL_CHANNEL = "gencow_app_wake_v1";
export const WORKFLOW_WAKE_SIGNAL_PAYLOAD = JSON.stringify({ kind: "workflow" });
